"use client"

import { useCreateAccount } from "@/hooks/CreateAccount/useCreateAccount"
import FormError from "@/components/FormError"
import { CreateAccountForm } from "./createAccountForm"

const CreateAccount = (props) => {
  const talonProps = useCreateAccount(props)

  const {
    errors,
    handleCancel,
    handleSubmit,
    handleEnterKeyPress,
    handleCancelKeyPress,
    isDisabled,
    initialValues,
    recaptchaWidgetProps,
    isSubmitting,
    setIsSubmitting,
    isAgree,
    setIsAgree,
    isLoading,
  } = talonProps

  return (
    <>
      <CreateAccountForm
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />

      <FormError
        allowErrorMessages={true}
        errors={Array.from(errors.values())}
      />
    </>
  )
}

export default CreateAccount
